import { render, staticRenderFns } from "./DragAndDropFiles.vue?vue&type=template&id=199d413a"
import script from "./DragAndDropFiles.vue?vue&type=script&lang=js"
export * from "./DragAndDropFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports